import { TOGGLE_MODAL_ROOM_BOX } from "../action/modalRoomBoxActions";

const initialState = {
  status: null,
  open: false,
};

const modalRoomBoxReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MODAL_ROOM_BOX:
      return {
        status: action.payload === state.status && state.open ? null : action.payload,
        open: action.payload !== state.status ? true : !state.open,
      };
    default:
      return state;
  }
};

export default modalRoomBoxReducer;
